// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2717":"d06c63bc","9981":"273ab7f9"}[chunkId] + ".chunk.css";
};